import { HOST_TOOL_NAMES } from "../../turns/turn-constants";
import type { SkillCall } from "../skill/skill-call";
import { skillNameFromInput } from "./skill-name-from-input";
import { stringField } from "./string-field";

// Keyed by the platform's own constants: a renamed host tool must break the
// build here, not silently fall back to a raw monospace row.
export const registryCalls: Record<string, (input: unknown) => SkillCall> = {
  [HOST_TOOL_NAMES.SKILL_SEARCH]: (input) => ({
    kind: "search",
    query: stringField(input, "query"),
  }),
  [HOST_TOOL_NAMES.SKILL_LOAD]: (input) => ({
    kind: "load",
    name: skillNameFromInput(input),
    via: "tool",
  }),
  [HOST_TOOL_NAMES.SAVE_SKILL]: (input) => ({
    kind: "save",
    name: stringField(input, "name"),
  }),
  [HOST_TOOL_NAMES.REQUEST_SKILL_ACTIVATION]: (input) => ({
    kind: "activate",
    name: stringField(input, "name"),
  }),
  [HOST_TOOL_NAMES.PROPOSE_SKILL_EDIT]: (input) => ({
    kind: "edit",
    name: stringField(input, "name"),
  }),
  [HOST_TOOL_NAMES.RECORD_REVIEW_LESSON]: (input) => ({
    kind: "lesson",
    scope: stringField(input, "scope"),
  }),
};
